import { Component, Input } from '@angular/core';
import { QueryParamDirective } from '@core-mkt/services/query-param/query-param.directive';

@Component({
  selector: 'app-ace-mode-highlight',
  standalone: true,
  imports: [QueryParamDirective],
  templateUrl: './ace-mode-highlight.component.html',
})
export class AceModeHighlightComponent {
  @Input() headline: string = '';
  @Input() description: string = '';
  @Input() linkUrl?: string;
  @Input() linkText?: string;
  @Input() badgeText: string = '';
  @Input() arrowDirection: 'top' | 'bottom' | 'right' | 'left' = 'right';
  @Input() hideOnMobile: boolean = true;

  get arrowRotation(): string {
    const rotations: Record<string, string> = {
      top: 'rotate(-90deg)',
      bottom: 'rotate(90deg)',
      right: 'rotate(0deg)',
      left: 'rotate(180deg)',
    };
    return rotations[this.arrowDirection] || rotations.right;
  }
}
